const MODAL_STATE_LOCAL_STORAGE_KEY = '@modalState';
const MODAL_REDUCER_NAME = 'modal';

const MODAL_INITIAL_STATE = {
  isVisible: false,
  modalProps: {},
};

// const LOGIN_MODAL_TYPE = {
//   NOT_SEOUL_2033_USER: 'notSeoul2033User',
//   LOW_LEVEL_USER: 'lowLevelUser',
// };

const MODAL_TYPES = {
  PAGE_MOVE: 'PAGE_MOVE',
};

export { MODAL_STATE_LOCAL_STORAGE_KEY, MODAL_REDUCER_NAME, MODAL_INITIAL_STATE, MODAL_TYPES };
